import LabeledSlider from '../classes/LabeledSlider';

const selectors = {
    el: '.js-labeled-slider:not(.is-ready)'
};

const init = () => {
    const els = document.querySelectorAll(selectors.el);
    els.forEach(el => {
        el.classList.add('is-ready');
        const labels = el.dataset.labels.split(', ');
        /* eslint-disable no-new */
        new LabeledSlider(el, labels);
    });
};

const module = () => {
    init();
    document.addEventListener('domUpdated', init);
};

export default module;